export const apiUrl = process.env.REACT_APP_API_URL
    ? process.env.REACT_APP_API_URL
    : 'https://highfiveapi.ngrok.io/'
export const slackAppId = process.env.REACT_SLACK_APP
    ? process.env.REACT_APP_SLACK_ID
    : 'A017ZU5FT3R'
